import { useRouteError } from "react-router-dom";

const Error = () => {
  const err = useRouteError();
  console.log(err.message);
  return (
    <div className="error">
      <h1>Error occurs!!!</h1>
      <h2>{err.status}:{err.statusText}</h2>
    </div>
  );
};
export default Error;
